<template>
  <div>
    <Navbar />
    <div class="no-sidebar">
      <slot />
    </div>
  </div>
</template>

<script>
import Navbar from "../components/Navbar";
import { mapState } from "vuex";

export default {
  components: {
    Navbar
  },
  computed: {
    ...mapState({
      isNavOpen: state => state.isNavOpen
    })
  }
};
</script>

<style scoped>
.no-sidebar {
  margin: 7.5rem 1.9rem 1rem 1.9rem;
}
</style>
